

setRecentlyViewedProducts();
const localViewed = localStorage.recentlyViewedProduct;
function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
  const recentlyViewedHtml = [];
  productData.map(item => {
    console.log(item)
    recentlyViewedHtml.unshift(`
    <div class="cstm-product-with-price__item">
        <a href="${item.productUrl}" class="cstm-product-with-price__item-img">
            <img src="${item.productImg}" >
        </a>
        <a href="${item.productUrl}" class="cstm-product-with-price__item-meta">
            <div class="cstm-product-with-price__item-type">
                ${item.productType ? item.productType : ''}
            </div>
            <div class="cstm-product-with-price__item-title">
                ${item.productTitle}
            </div>
            <div class="cstm-product-with-price__price">
              <div class="cstm-product-with-price__price-price">
                <span class="product-main-price" >
                  ${item.productPrice}
                </span>
              </div>
            </div>
        </a>
    </div>
   `);
  });
  const newProductData = `${recentlyViewedHtml.join("")}`;
  const fullContent = document.getElementsByClassName("recently-viewed");
  fullContent[0].innerHTML = newProductData;
  document.querySelector('.recently-viewed__title').style.display = 'block';
  var myLazyLoad = new LazyLoad();
  // After your content has changed...
  myLazyLoad.update();
  console.log('loaded')
}

document.addEventListener("DOMContentLoaded", function (event) {
  getRecentlyViewedProducts();
  setInterval(function(){
      var myLazyLoad = new LazyLoad();
      // After your content has changed...
      myLazyLoad.update();
  }, 500)
});

